module.exports = __webpack_public_path__ + "img/ahmed-circle.df04de47.png";